import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';

export function TaxonomyLensEmptyState() {
  return <GenericEmptyState dataTitle="EU taxonomy data" />;
}
